import 'bootstrap';
import { loopHeader } from "./enhancers/headerEnhancer";
import { collapsables } from "./enhancers/collapsableEnhancer";
import { smoothScrolling } from "./enhancers/smoothScrollingEnhancer";


loopHeader();
collapsables();
smoothScrolling();
